import { render, staticRenderFns } from "./WsParticipantsPersonalDetails.vue?vue&type=template&id=3193b678&scoped=true"
import script from "./WsParticipantsPersonalDetails.vue?vue&type=script&lang=js"
export * from "./WsParticipantsPersonalDetails.vue?vue&type=script&lang=js"
import style0 from "./WsParticipantsPersonalDetails.vue?vue&type=style&index=0&id=3193b678&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3193b678",
  null
  
)

export default component.exports